import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

// Footer

export const Wrapper = styled.div`
  padding: 40px 24px;
  background: ${props => props.theme.brand.ink};
  color: ${props => props.theme.brand.chalk};
  max-width: 1232px;
  margin: 40px auto 0;
  border-radius: 40px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    padding: 48px 40px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 28px;
  }

  @media screen and (min-width: 1280px) {
    padding: 64px 72px;
    display: flex;
    justify-content: space-between;
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 36px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    flex-basis: 100%;
    justify-content: space-between;
    gap: 24px;
    padding-top: 28px;
    border-top: 1px solid rgba(246, 245, 242, 0.12);
  }

  @media screen and (min-width: 1280px) {
  }
`;

export const Logo = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: 16px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    width: 170px;
    margin-bottom: 18px;
  }

  @media screen and (min-width: 1280px) {
    width: 190px;
    margin-bottom: 20px;
  }
`;

export const BoxFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: 1280px) {
  }
`;

// Contacts

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    gap: 8px;
  }

  @media screen and (min-width: 1280px) {
    gap: 10px;
  }
`;

export const Title = styled.h4`
  font-family: ${props => props.theme.fonts.display};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${props => props.theme.brand.chalk};
  font-size: 15px;
  margin-bottom: 6px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    font-size: 18px;
    margin-bottom: 8px;
  }

  @media screen and (min-width: 1280px) {
    font-size: 22px;
    margin-bottom: 12px;
  }
`;

export const Text = styled.p`
  font-size: 14px;
  color: ${props => props.theme.brand.chalk};
  opacity: 0.85;

  &:hover,
  :focus {
    color: ${props => props.theme.colors.secondary};
    opacity: 1;
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    font-size: 15px;
  }

  @media screen and (min-width: 1280px) {
    font-size: 16px;
  }
`;

// TimeTable (Box)

export const TextDate = styled.p`
  font-size: 14px;
  color: ${props => props.theme.brand.chalk};
  opacity: 0.85;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    font-size: 15px;
  }

  @media screen and (min-width: 1280px) {
    font-size: 16px;
  }
`;

// Confidential (Box, TextDate)

// ForClients (Box, Title)

export const Link = styled(NavLink)`
  font-size: 14px;
  color: ${props => props.theme.brand.chalk};
  opacity: 0.85;
  transition: ${props => props.theme.transition.main};

  &:hover,
  :focus {
    color: ${props => props.theme.colors.secondary};
    opacity: 1;
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    font-size: 15px;
  }

  @media screen and (min-width: 1280px) {
    font-size: 16px;
  }
`;

// Catalog (Box, Title, Link)

// SocialMediaFooter

export const List = styled.ul`
  display: flex;
  gap: 6px;
`;

export const Item = styled.li`
  color: ${props => props.theme.colors.hoverColor};
  opacity: 0.8;
  transition: ${props => props.theme.transition.main};
  cursor: pointer;
  display: block;
  height: 20px;

  &:hover,
  :focus {
    opacity: 1;
    transform: scale(1.05);
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    height: 22px;
  }

  @media screen and (min-width: 1280px) {
    height: 24px;
  }
`;
